import { ReactComponent as SongIcon } from 'resources/images/song.svg';
import { ReactComponent as PlaylistIcon } from 'resources/images/playlist.svg';
import { ReactComponent as ReleaseIcon } from 'resources/images/release.svg';
import { ReactComponent as SongSolidIcon } from 'resources/images/song-solid.svg';
import { ReactComponent as ReleaseSolidIcon } from 'resources/images/release-solid.svg';
import { routes } from 'app/routing/routesConfig';

export const mainMenu = [
  {
    to: routes.songs.path,
    label: 'Songs',
    icon: SongIcon,
    activeIcon: SongSolidIcon,
  },
  {
    to: routes.playlists.path,
    label: 'Playlists',
    icon: PlaylistIcon,
  },
  {
    to: routes.releases.path,
    label: 'Releases',
    icon: ReleaseIcon,
    activeIcon: ReleaseSolidIcon,
  },
];
